import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodasComissoes(contratoId) {
        return axiosJwt
            .get(`${api}/contratos/${contratoId}/comissoes`)
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },
    obterComissaoPorId(contratoId, comissaoId) {
        return axiosJwt
            .get(`${api}/contratos/${contratoId}/comissoes/${comissaoId}`)
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },
    excluirComissao(comissaoId, contratoId) {
        return axiosJwt
            .delete(
                `${api}/contratos/${contratoId}/comissoes/${comissaoId}`
            )
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },
    inserirComissao(contratoId, data) {
        return axiosJwt
            .post(`${api}/contratos/${contratoId}/comissoes/inserir`, data)
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    },
    atualizarComissao(data){
       return axiosJwt.put(`${api}/contratos/${data.contratoId}/comissoes/atualizar`, data)
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                return errorHandler(error)
            })
    }
}
